/**
 * Created by zad on 17/1/13.
 */
import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import styles from './Loading.scss';

const loaderPrefix = 'loader';
// eslint-disable-next-line no-underscore-dangle
const _type = {
  size: ['small', 'large'],
};

export default function Loader({ size = undefined, tip = '', hasMask = false, loading, loaderClassName }) {
  const sizeSuffix = ({
    large: 'lg',
    small: 'sm',
  })[size];

  const loadingClass = classNames(`${styles[loaderPrefix]}`, loaderClassName, {
    [`${styles[`${loaderPrefix}-${sizeSuffix}`]}`]: size && _.includes(_type.size, size),
    [`${styles[`${loaderPrefix}-show-tip`]}`]: !!tip,
    [`${styles[`${loaderPrefix}-is-loading`]}`]: loading,
    [`${styles[`${loaderPrefix}-has-mask`]}`]: hasMask,
  });

  return (
    <div className={loadingClass}>
      <div className={`${styles[`${loaderPrefix}-entity`]}`}>
        <svg className={`${styles[`${loaderPrefix}-svg`]}`} viewBox="25 25 50 50">
          <circle className={`${styles[`${loaderPrefix}-circle`]}`} cx="50" cy="50" r="20" fill="none"/>
        </svg>
      </div>
      {!!tip && <div className={`${styles[`${loaderPrefix}-tip`]}`}>{tip.toString()}</div>}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Loading/Loader.js